/*
 * Copyright 2017-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

// Using CJS so these can be used with Detox tests.
module.exports = {
  AUTH: {
    BACK_TO_SIGN_IN_BUTTON: "aws-amplify__auth--back-to-sign-in-button",
    CHANGE_PASSWORD_TEXT: "aws-amplify__auth--change-password-text",
    CONFIRM_A_CODE_BUTTON: "aws-amplify__auth--confirm-a-code-button",
    CONFIRM_BUTTON: "aws-amplify__auth--confirm-button",
    CONFIRM_SIGN_IN_TEXT: "aws-amplify__auth--confirm-sign-in-text",
    CONFIRM_SIGN_UP_TEXT: "aws-amplify__auth--confirm-sign-up-text",
    CONFIRMATION_CODE_INPUT: "aws-amplify__auth--confirmation-code-input",
    EMAIL_INPUT: "aws-amplify__auth--email-input",
    ERROR_ROW_TEXT: "aws-amplify__auth--error-row-text",
    FORGOT_PASSWORD_BUTTON: "aws-amplify__auth--forgot-password-button",
    FORGOT_PASSWORD_TEXT: "aws-amplify__auth--forgot-password-text",
    GREETING_SIGNED_IN_TEXT: "aws-amplify__auth--greeting-signed-in-text",
    GREETING_SIGNED_OUT_TEXT: "aws-amplify__auth--greeting-signed-out-text",
    LOADING_TEXT: "aws-amplify__auth--loading-text",
    PASSWORD_INPUT: "aws-amplify__auth--password-input",
    PHONE_INPUT: "aws-amplify__auth--phone-input",
    RESEND_CODE_BUTTON: "aws-amplify__auth--resend-code-button",
    SEND_BUTTON: "aws-amplify__auth--send-button",
    SIGN_IN_BUTTON: "aws-amplify__auth--sign-in-button",
    SIGN_IN_TO_YOUR_ACCOUNT_TEXT:
      "aws-amplify__auth--sign-in-to-your-account-text",
    SIGN_OUT_BUTTON: "aws-amplify__auth--sign-out-button",
    SIGN_UP_BUTTON: "aws-amplify__auth--sign-up-button",
    SIGN_UP_TEXT: "aws-amplify__auth--sign-up-text",
    SKIP_BUTTON: "aws-amplify__auth--skip-button",
    SUBMIT_BUTTON: "aws-amplify__auth--submit-button",
    USERNAME_INPUT: "aws-amplify__auth--username-input",
    VERIFY_CONTACT_PICKER: "aws-amplify__auth--verify-contact-picker",
    VERIFY_CONTACT_TEXT: "aws-amplify__auth--verify-contact-text",
    VERIFY_BUTTON: "aws-amplify__auth--verify-button",
  },
};
